<template>
    <div id="alert_message">
        <v-expansion-panels v-model="activePanels"
            class="panel" 
            accordion 
            tile
        >
            <v-expansion-panel v-for="(alert_message, index) in alert_messages" 
                :key="index"
            >
                <v-expansion-panel-header class="panel-header"
                    hide-actions
                >
                    <div>
                        <v-icon color="white"> 
                            {{ activePanels == index ? 'icon-arrow-drop-down' : 'icon-arrow-drop-right' }}
                        </v-icon>
                        <font color="white" 
                            class="panel-header__title"
                        > 
                            {{ alert_message.panel_title }}
                        </font>
                    </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="panel-content">
                    <template v-if="alert_message.contents">
                        <div v-for="(content, content_index) in alert_message.contents" 
                            :key="`content_${content_index}`"
                        >
                            <div v-for="(_section, _section_index) in content.section" 
                                :key="`section${_section_index}`"
                                class="panel-content__container" 
                            >
                                <div class="panel-content__title">
                                    {{ _section.h2 }}
                                </div>
                                <div v-if="_section.side"
                                    class="panel-content__divide" 
                                >
                                    <div class="panel-content__divide--left">
                                        <div v-for="(_paragraph, _paragraph_index) in _section.paragraph"
                                            :key="`paragraph${_paragraph_index}`"
                                            class="panel-content__font"
                                        >
                                            <div class="panel-content__subtitle">
                                                {{ _paragraph.h3 }}
                                            </div>
                                            <div v-html="_paragraph.words" />
                                        </div>
                                    </div>
                                    <div class="panel-content--right">
                                        <div v-for="(item, item_index) in _section.side"
                                            :key="`item_${item_index}`"
                                            class="panel-content__detail"
                                        >
                                            {{ item }}
                                        </div>
                                    </div>
                                </div>
                                <div v-else 
                                    class="panel-content__all"
                                >
                                    <div v-for="(_paragraph, _paragraph_index) in _section.paragraph"
                                        :key="`paragraph${_paragraph_index}`"
                                        class="panel-content__font"
                                    >
                                        <div class="panel-content__subtitle">
                                            {{ _paragraph.h3 }}
                                        </div>
                                        <div v-html="_paragraph.words" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
    export default {
        name: 'AlertMessage',

        props: {
            alert_messages: {
                type: Array,
                required: true
            },
        },

        data() {
            return {
                activePanels: 0,
            }
        },
    }
</script>

<style scoped>
    .panel-content >>> .v-expansion-panel-content__wrap {
        margin: 0;
        padding: 0;
    }
</style>

<style lang="scss" scoped>
    .panel {
        border-radius: 0 0 4px 4px;
    }

    .panel-header {
        background: var(--linear-gradient-color-1);

        &__title {
            padding-left: 5px;
            font-weight: 500;
        }
    }

    .panel-content {
        overflow-y: auto;
        margin: 0 0 0 28px;
        padding: 16px 27px;
        height: 30vh;
        max-height: 308px;
        box-sizing: border-box;
        border-left: 1px solid var(--grey-pipe);

        &__divide {
            display: flex;

            &--left {
                max-width: 348px;
            }
        }

        &__all {
            padding-bottom: .25rem;
        }

        &__title {
            padding: 8px 0;
            font-size: 1.25em;
            font-weight: 600;
            letter-spacing: .8px;
            line-height: 1.5;
            color: var(--base-blue);
        }

        &__subtitle {
            font-size: .875em;
            font-weight: 600;
            letter-spacing: .6px;
            line-height: 1.43;
            color: var(--base-dark-blue);
        }

        &__font {
            font-size: .875em;
            letter-spacing: .5px;
            line-height: 1.43;
            color: var(--base-dark-blue);
        }

        &__detail {
            padding: 0 16px;
            font-size: .875em;
            letter-spacing: .6px;
            line-height: 1.43;
            color: var(--base-gray);
        }
    }
</style>


